import { Icon } from '@iconify/react';
import OrdersIcon from '../../assets/OrdersIcon';
import FacilitiesIcon from '../../assets/FacilitiesIcon';
import ProfileIcon from '../../assets/ProfileIcon';
import BankDetailsIcon from '../../assets/BankDetailsIcon';
import { MessageIcon } from '../../assets/MessageIcon';
import WalletIcon from '../../assets/WalletIcon';
import FinancialsIcon from '../../assets/FinancialsIcon';
import {
  BankIcon,
  ExploreIcon,
  FacilitiesAndServicesIcon,
  FeesIcon,
  MessagesIcon,
  OrderIcon,
  PatientIcon,
  PayoutsIcon,
  ProvidersIcon,
  DashboardIcon,
} from '../../assets';

// Common navigation items used across roles
const commonLinks = [
  {
    id: 100,
    title: 'Change Password',
    url: '/dashboard/change-password',
    icon: <Icon icon="mdi:password-outline" />,
  },
  {
    id: 101,
    title: 'Logout',
    icon: <Icon icon="solar:logout-outline" />,
    event: 'event',
  },
];

const roleNavLinks = {
  5: [
    {
      id: 1,
      title: 'My Profile',
      icon: <ProfileIcon />,
      url: '/dashboard/profile/',
    },
    {
      id: 2,
      title: 'Place a new order',
      icon: <Icon icon="material-symbols:explore-outline" />,
      url: '/dashboard/',
    },
    {
      id: 3,
      title: 'My Messages',
      icon: <MessageIcon />,
      url: '/dashboard/messages',
    },
    {
      id: 4,
      title: 'My Orders',
      icon: <OrdersIcon />,
      url: '/dashboard/order/',
    },
    {
      id: 8,
      title: 'My Patients',
      icon: <Icon icon="fa-solid:user-injured" />,
      url: '/dashboard/patient/',
    },
    {
      id: 15,
      title: 'My eWallet',
      icon: <WalletIcon />,
      url: '/dashboard/wallet',
      heading: 'PAYMENTS',
    },
  ],
  4: [
    {
      id: 0,
      title: 'Dashboard',
      icon: <DashboardIcon />,
      url: '/dashboard/mainDashboard',
    },
    {
      id: 1,
      title: 'My Orders',
      icon: <OrdersIcon />,
      url: '/dashboard/order/',
    },
    {
      id: 2,
      title: 'Facilities and Services',
      icon: <FacilitiesIcon />,
      url: '/dashboard/',
    },
    {
      id: 3,
      title: 'Profile',
      icon: <ProfileIcon />,
      url: '/dashboard/profile/',
    },
    {
      id: 4,
      title: 'Bank Details',
      icon: <BankDetailsIcon />,
      url: '/dashboard/bank-details/',
    },
    {
      id: 5,
      title: 'My Messages',
      icon: <MessageIcon />,
      url: '/dashboard/messages',
    },
    {
      id: 6,
      title: 'My Financials',
      icon: <FinancialsIcon />,
      url: '/dashboard/financials',
    },
  ],
  3: [
    {
      id: 0,
      title: 'Dashboard',
      icon: <DashboardIcon />,
      url: '/dashboard/mainDashboard',
    },
    {
      id: 1,
      title: 'My Profile',
      icon: <ProfileIcon />,
      url: '/dashboard/profile/',
    },
    {
      id: 2,
      title: 'Place a new order',
      icon: <Icon icon="material-symbols:explore-outline" />,
      url: '/dashboard/',
    },
    {
      id: 3,
      title: 'Facilities and Services',
      icon: <FacilitiesIcon />,
      url: '/dashboard/facilities',
    },
    {
      id: 4,
      title: 'My Orders',
      icon: <OrdersIcon />,
      url: '/dashboard/order/',
    },
    {
      id: 5,
      title: 'My Patient',
      icon: <Icon icon="fa-solid:user-injured" />,
      url: '/dashboard/patient/',
    },
    {
      id: 6,
      title: 'Fees',
      icon: <Icon icon="fa-solid:money-bill-wave" />,
      url: '/dashboard/fees/',
    },
    {
      id: 7,
      title: 'My Messages',
      icon: <Icon icon="lets-icons:chat" />,
      url: '/dashboard/messages',
    },
    {
      id: 13,
      title: 'User',
      icon: <Icon icon="mdi:account-group" />,
      url: '/dashboard/users',
    },
  ],
  2: [
    {
      id: 0,
      title: 'Dashboard',
      icon: <DashboardIcon />,
      url: '/dashboard/mainDashboard',
    },
    {
      id: 1,
      title: 'My Profile',
      icon: <ProfileIcon />,
      url: '/dashboard/profile/',
    },
    {
      id: 2,
      title: 'Place a new order',
      icon: <ExploreIcon />,
      url: '/dashboard/',
    },
    {
      id: 3,
      title: 'Facilities and Services',
      icon: <FacilitiesAndServicesIcon />,
      url: '/dashboard/facilities',
    },
    {
      id: 4,
      title: 'My Orders',
      icon: <OrderIcon />,
      url: '/dashboard/order/',
    },
    {
      id: 5,
      title: 'My Patient',
      icon: <PatientIcon />,
      url: '/dashboard/patient/',
    },
    {
      id: 10,
      title: 'Bank Details',
      icon: <BankIcon />,
      url: '/dashboard/bank-details/',
    },
    {
      id: 11,
      title: 'Payout',
      icon: <PayoutsIcon />,
      url: '/dashboard/payout/',
      heading: 'PAYMENTS',
    },
    {
      id: 6,
      title: 'Fees',
      icon: <FeesIcon />,
      url: '/dashboard/fees/',
      heading: 'PAYMENTS',
    },
    {
      id: 12,
      title: 'New Providers',
      icon: <ProvidersIcon />,
      url: '/dashboard/suggestion/',
      heading: 'PAYMENTS',
    },
    {
      id: 15,
      title: 'My eWallet',
      icon: <WalletIcon />,
      url: '/dashboard/wallet',
      heading: 'PAYMENTS',
    },
    {
      id: 7,
      title: 'My Messages',
      icon: <MessagesIcon />,
      url: '/dashboard/messages',
      heading: 'OTHERS',
    },
  ],
  1: [
    {
      id: 0,
      title: 'Dashboard',
      icon: <DashboardIcon />,
      url: '/dashboard/mainDashboard',
    },
    {
      id: 1,
      title: 'Facilities and Services',
      icon: <FacilitiesIcon />,
      url: '/dashboard/',
    },
    {
      id: 2,
      title: 'User Profile',
      icon: <Icon icon="radix-icons:avatar" />,
      url: '/dashboard/profile',
    },
    {
      id: 3,
      title: 'Bank Details',
      icon: <BankDetailsIcon />,
      url: '/dashboard/bank-details',
    },
    {
      id: 4,
      title: 'Patient Profile',
      icon: <Icon icon="fluent:patient-20-regular" />,
      url: '/dashboard/patient-profile',
    },
    {
      id: 5,
      title: 'My Messages',
      icon: <MessageIcon />,
      url: '/dashboard/messages',
    },
  ],
};

// Combine role-based links with common links
const navlinks = {
  roles: Object.entries(roleNavLinks).map(([role, navigationLinks]) => ({
    role,
    navigationLinks: [...navigationLinks, ...commonLinks],
  })),
};

export { navlinks };
